"use client";

import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { X, Mail, MessageSquare, Phone } from "lucide-react";
export default function RequestAnEstimate() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleModal = () => setIsOpen(!isOpen);
  return <section data-section-id="257422" id="request-an-estimate" className="relative w-full py-20 bg-cover bg-center !bg-[url(https://gfccontractor.com/wp-content/uploads/2026/06/OIG3-5.jpeg)] dark bg-background !h-[895.703px] md:py-32 text-foreground/18 !bg-[url(https://gfccontractors.com/wp-content/uploads/2026/06/OIG1.DYSqzTk3YRWOX.jpeg)]">
      {}
      <div className="absolute inset-0 !text-[rgba(250,250,250,1)] !opacity-[0.67] !bg-[rgba(0,0,0,0.49)]"></div>

      <div className="container relative z-10 mx-auto px-4 max-w-5xl">
        <div className="text-center mb-12 md:mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white font-default mb-6 uppercase tracking-wider">
            Request An Estimate
          </h2>
          <p className="text-white/90 text-base md:text-lg leading-relaxed font-mono uppercase tracking-wide mb-10">
            Let's build your dream home. Whether it's a custom build or a luxury remodel, 
            Miguel Alonzo and the God Father Company team deliver excellence across Austin. 
            Connect with us to share your vision.
          </p>
          
          <Button onClick={toggleModal} className="text-primary-foreground text-sm inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-9 has-[>svg]:px-3 rounded-md px-10 py-8 font-default font-bold uppercase tracking-widest border-none transition-all duration-300 shadow-lg !text-2xl !text-[rgba(0,0,0,1)] !opacity-[1] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-white/90 bg-primary-foreground/50">
            Request an Estimate
          </Button>
        </div>
      </div>

      {}
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          {}
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={toggleModal}></div>
          
          {}
          <div className="relative bg-black border border-white/20 w-full max-w-md p-8 md:p-12 rounded-md shadow-2xl animate-in fade-in zoom-in duration-300">
            <Button variant="ghost" onClick={toggleModal} className="absolute top-4 right-4 text-white/50 hover:text-white hover:bg-white/10 transition-colors p-2 h-auto rounded-md" aria-label="Close modal">
              <X className="size-6" />
            </Button>

            <div className="text-center space-y-8">
              <div className="space-y-2">
                <h3 className="text-2xl font-bold text-white uppercase tracking-wider font-default">
                  Get In Touch
                </h3>
                <p className="text-white/60 font-mono text-sm uppercase tracking-tight">
                  Choose your preferred method of contact
                </p>
              </div>

              <div className="flex flex-col gap-4">
                <Button asChild variant="outline" className="w-full py-8 border-white/20 text-white hover:bg-white hover:text-black rounded-md uppercase tracking-widest font-bold transition-all duration-300">
                  <Link to="mailto:gfcllcs@gmail.com" className="flex items-center justify-center gap-3">
                    <Mail className="size-5" />
                    Email Us
                  </Link>
                </Button>

                <Button asChild variant="outline" className="w-full py-8 border-white/20 text-white hover:bg-white hover:text-black rounded-md uppercase tracking-widest font-bold transition-all duration-300">
                  <Link to="sms:512-956-0639" className="flex items-center justify-center gap-3">
                    <MessageSquare className="size-5" />
                    Text Us
                  </Link>
                </Button>

                <Button asChild variant="outline" className="w-full py-8 border-white/20 text-white hover:bg-white hover:text-black rounded-md uppercase tracking-widest font-bold transition-all duration-300">
                  <Link to="tel:512-956-0639" className="flex items-center justify-center gap-3">
                    <Phone className="size-5" />
                    Call Us
                  </Link>
                </Button>
              </div>
              
              <p className="text-white/40 text-[10px] uppercase tracking-[0.2em] font-mono">
                God Father Company • Austin, TX
              </p>

              <Button onClick={toggleModal} variant="outline" className="w-full py-6 border-white/20 text-white hover:bg-white hover:text-black rounded-md uppercase tracking-widest font-bold transition-all duration-300">
                GO BACK
              </Button>
            </div>
          </div>
        </div>}
    </section>;
}